<template>
  <div style="margin-top:200px">
    <van-button type="primary" round @click="gotoWx('')">微信支付</van-button>
    <van-button type="primary" style="background:#1989fa;color" round @click="gotoMy">支付宝支付</van-button>
    <!-- <van-button type="primary" round @click="aaaaa()">aaaaa</van-button>
    <van-button type="primary" round @click="ccccc">ccccc</van-button> -->
  </div>
</template>

<script>

import axios from 'axios';
export default {
  data() {
    return {
      htmlUrl: 'https://test-6gagz5q5ee925671-1311542182.tcloudbaseapp.com/jump-mp.html?sign=9889001c7a2b837f04e8c68a4475f7a0&t=1652172082',
      resourceAppid: 'wx64b908c41de0d1a3',
      AppSecret: "16940edc83a3927f3bf8fa54ed68f8a3",
      resourceEnv: 'test-6gagz5q5ee925671',
      username: 'gh_8ad101a20185',

      // resourceAppid: 'wx28c123dde92ffe81',
      // AppSecret: "fda75504398e832d29e0cedfe7fc790f",
      // resourceEnv: 'mfcloud-4gghjtib6f13e839',
      // username: 'gh_f511946d5d30',
    
      envData:{
        production:{
          htmlUrl: 'https://mfcloud-4gghjtib6f13e839-1301940819.tcloudbaseapp.com/jump-mp.html?sign=83872671be9f6f645be376ab514d9ee9&t=1652172146',
          resourceAppid: 'wx28c123dde92ffe81',
          AppSecret: "fda75504398e832d29e0cedfe7fc790f",
          resourceEnv: 'mfcloud-4gghjtib6f13e839',
          username: 'gh_f511946d5d30',
        },
        test:{
          htmlUrl: 'https://test-6gagz5q5ee925671-1311542182.tcloudbaseapp.com/jump-mp.html?sign=9889001c7a2b837f04e8c68a4475f7a0&t=1652172082',
          resourceAppid: 'wx64b908c41de0d1a3',
          AppSecret: "16940edc83a3927f3bf8fa54ed68f8a3",
          resourceEnv: 'test-6gagz5q5ee925671',
          username: 'gh_8ad101a20185',
        }
      }


    };
  },
  async mounted() {
    if (process.env.NODE_ENV == 'production') {
      this.htmlUrl = this.production.htmlUrl
      this.resourceAppid = this.production.resourceAppid
      this.AppSecret = this.production.AppSecret
      this.resourceEnv = this.production.resourceEnv
      this.username = this.production.username
    }
    this.$loading.hide();
    this.getEnv();
  },
  methods: {
    async getEnv() {

      const ua = window.navigator.userAgent.toLowerCase();

      //判断是不是支付宝
      if (ua.match(/AlipayClient/i) == "alipayclient") {
        console.log('支付宝');
        this.gotoMy()
        return
      }

      //判断是不是微信
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log('微信');
        console.time('time')
        // 获取access_token
        axios(`/weixin/cgi-bin/token?grant_type=client_credential&appid=${this.resourceAppid}&secret=${this.AppSecret}`).then(res => {
          setTimeout(() => {
            console.log('res.data.access_token:' + res.data.access_token);
            // 获取云函数返回 schemeUrl
            axios({
              method: 'post',
              url: `/weixin/tcb/invokecloudfunction?access_token=${res.data.access_token}&env=${this.resourceEnv}&name=public`,
              data: {
                options: window.location.search.substr(1)
              }
            }).then(res => {
              this.gotoWx(JSON.parse(res.data.resp_data).openlink)
            }).catch((err) => {
              this.gotoWx()
            })
          }, 60);
        }).catch((err) => {
          this.gotoWx()
        })
        return
      }

      // console.log('啥也不是');
      // //哪个都不是
      // return "啥也不是";
    },
    // 跳转支付宝小程序
    gotoMy() {
      window.location.href = `alipays://platformapi/startapp?appId=2021003128631144&page=pages/payment/index&query=${encodeURIComponent(window.location.search.substr(1) + '&payType=codePay')}`;

    },
    // 跳转微信小程序
    gotoWx(openlink = "") {
      if (openlink) {
        window.location.href = openlink
      } else {
        window.history.go(-1);
        window.location.href = `${this.htmlUrl}&resourceAppid=${this.resourceAppid}&resourceEnv=${this.resourceEnv}&username=${this.username}`
      }
    },
  },
};
</script>
